export const setProfilo = (id) => {
    var prof = "";
    switch (id) {
      case 1:
        prof = "Admin"
        break;
      case 2:
        prof = "AM"
        break;
      case 3:
        prof = "PM"
        break;
      case 4:
        prof = "Man"
        break;
      case 5:
        prof = "Requestor"
        break;
      case 6:
        prof = "Guest"
        break;
      case 7:
        prof = "Disabled"
        break;
      case 8:
        prof = "Super Admin"

      default:
        break;
    }
    return prof;
  };

export const hasAllowedRole = (role, allowedRoles = []) => {
  return allowedRoles.includes(role);
};